// Action Types
export enum Types {
  LOAD_MANIFESTATIONS = 'manifestations/LOAD_MANIFESTATIONS',
  LOAD_MANIFESTATIONS_SUCCESS = 'manifestations/LOAD_MANIFESTATIONS_SUCCESS',
  LOAD_MANIFESTATIONS_FAILURE = 'manifestations/LOAD_MANIFESTATIONS_FAILURE',

  UPDATE_MANIFESTATIONS_SETTINGS = 'manifestations/UPDATE_MANIFESTATIONS_SETTINGS',

  CLEAR_MANIFESTATIONS_STATE = 'manifestations/CLEAR_INVOICES_STATE'
}

export interface IManifestationsState {
  loading: boolean;

  error: boolean;
  errorMessage?: string;

  fetched: boolean;

  manifestations?: ManifestationDataProps[];
  selectedCustomerId: string;
}

export interface ManifestationDataProps {
  key: string;
  orderNumber: string;
  orderCreatedDate: string;
  orderCreatedTime: string;
  status: string;
  contactName: string;
  contactPhone: string;
  sellerName: string;
  occurrence: string;
  vehicleOnSite: string;
  manifestationDetails: string;
  deniedCause: string;
}

export interface ManifestationResponseProps {
  id: string;
  number: string;
  created_at: string;
  contact: { name: string; phone: string };
  representative: { name: string };
  is_transport_at_location: boolean;
  is_rejected: boolean;
  reason: { description: string; incident: string; cause: string };
  status: string;
}

export const ALLOWED_STATUS = [
  'Reclamação aberta',
  'Devolução do material',
  'Reclamação em análise',
  'Reclamação resolvida',
  'Reclamação negada'
] as const;

export type StatusType = (typeof ALLOWED_STATUS)[number];

export const statusVariantMap: Record<
  StatusType,
  'info' | 'primary' | 'success' | 'danger'
> = {
  'Reclamação aberta': 'info',
  'Devolução do material': 'primary',
  'Reclamação em análise': 'primary',
  'Reclamação resolvida': 'success',
  'Reclamação negada': 'danger'
};

export const tagStatusMaps: Record<StatusType, string> = {
  'Reclamação aberta': 'view_reclamacao_aberta',
  'Devolução do material': 'view_devolucao_material',
  'Reclamação em análise': 'view_reclamacao_analise',
  'Reclamação resolvida': 'view_reclamacao_resolvida',
  'Reclamação negada': 'view_reclamacao_negada'
};
